<template>
  <el-form class="otp-login" label-position="top" label-width="80px" :model="formOTP">
    <el-form-item label="OTP" prop="otp" :rules="otpRules">
      <el-input v-model="formOTP.otp" placeholder="OTP" :maxlength="6">
        <el-button slot="append" :class="`send-btn ${isCounting ? 'btn_counting' : ''}`" :disabled="isCounting"
          @click="handleSend">{{
            isCounting ? `${countTime}s` : $t('login.send')
          }}</el-button>
      </el-input>
    </el-form-item>
    <el-form-item class="btn-group">
      <el-button type="primary" class="confirm-btn" @click="handleConfirm" :disabled="!!!formOTP.otp">{{
        $t('login.confirm')
      }}</el-button>
      <el-button class="cancel-btn" @click="handleCancel" style="color: rgb(144, 190, 253)">{{ $t('login.cancel') }}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
export default {
  name: 'OTP',
  data() {
    return {
      formOTP: {
        otp: '',
      },
      isCounting: false,
      timer: null,
      countTime: 59,
      sendFlag: false,
      otpRules: {
        message: this.$t('login.pleaseEnterSixDigitVerificationCode'),
        validator: (rule, value, callback) => {
          if (!/^\d{6}$/.test(value)) {
            callback(new Error(this.$t('login.pleaseEnterSixDigitVerificationCode')))
          } else {
            callback()
          }

        },
        trigger: 'blur',
      }
    };
  },
  methods: {
    async handleConfirm() {
      try {
        const { data } = await this.$http.post(`/kj-sys/basecode/checkCode?code=${this.formOTP.otp}`)
        if (data.data) {
          this.$emit('confirm');
        } else {
          this.$message.error(this.$t('login.verificationCodeError'));
        }
      } catch (error) {

      }
    },
    async handleSend() {
      if (this.sendFlag) {
        return;
      }
      this.sendFlag = true;
      try {
        this.isCounting = true;
        this.timer = setInterval(() => {
          this.countTime--;
          if (this.countTime <= 0) {
            clearInterval(this.timer);
            this.isCounting = false;
            this.countTime = 59;
          }
        }, 1000)
        await this.$http.post('/kj-sys/basecode/sendCode')
      } catch (error) {
        clearInterval(this.timer);
        this.isCounting = false;
        this.countTime = 59;
      }
      this.sendFlag = false;
    },
    handleCancel() {
      this.$emit('cancel');
    }
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .el-input-group__append {
    border: none;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    overflow: hidden;
  }

  .el-input-group--append .el-input__inner {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  
}
.otp-login ::v-deep .el-form-item__label {
  color: #606266;
  font-size: 12px;
}
.send-btn {
  background: linear-gradient(27deg, #3b8cfa 0%, #b2d2ff 100%);
  border: none;

  &.btn_counting {
    background: #C2C6CC;
  }

  &.el-button.is-disabled,
  .el-button.is-disabled:focus,
  .el-button.is-disabled:hover {
    background-color: #C2C6CC;
  }

  ::v-deep {
    span {
      color: #fff;
    }
  }

}

.btn-group {
  .el-button {
    display: block;
    width: 100%;
    margin: 0;
    padding: 8px 20px;
    border-radius: 20px;
    color: #fff
  }

  .el-button+.el-button {
    margin-top: 10px;
  }

  .confirm-btn {
    background: linear-gradient(63deg, #3b8cfa 0%, #b2d2ff 100%);
  }

  .cancel-btn {
    background: transparent;
  }
}
</style>
